import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import About from "@/components/About";
import HowWeWork from "@/components/HowWeWork";
import ProblemSolution from "@/components/ProblemSolution";
import Certifications from "@/components/Certifications";
import BrandShowcase from "@/components/BrandShowcase";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import LeadMagnet from "@/components/LeadMagnet";
import CtaBanner from "@/components/CtaBanner";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import useReveal from "@/hooks/useReveal";
import usePageMeta from "@/hooks/usePageMeta";

export default function LandingPage() {
  useReveal();
  usePageMeta({
    title: "Great Solutions US · Impuestos, ITIN, LLC, Notaría y Seguros en Florida",
    description: "Yohaly Acevedo — Notary Public FL, IRS Certified, CAA. Preparación de impuestos, ITIN, formación de LLC, contabilidad, notarizaciones y seguros en Florida.",
  });

  useEffect(() => {
    // On mount, if hash present, scroll to it
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 200);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#0f172a]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyChoose />
        <About />
        <HowWeWork />
        <ProblemSolution />
        <Certifications />
        <BrandShowcase />
        <Testimonials />
        <FAQ />
        <LeadMagnet />
        <CtaBanner />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
